// Displays a datetime in two timezones side by side (UTC + America/New_York).
// Compact by default; use `stacked` to render on two lines.
export default function DualClock({ iso, stacked = false, className = "" }) {
  if (!iso) return null;
  const d = new Date(iso);
  const utc = d.toLocaleString("en-GB", {
    timeZone: "UTC",
    weekday: "short", month: "short", day: "numeric",
    hour: "2-digit", minute: "2-digit",
    hour12: false,
  });
  const est = d.toLocaleString("en-US", {
    timeZone: "America/New_York",
    weekday: "short", month: "short", day: "numeric",
    hour: "2-digit", minute: "2-digit",
    hour12: false,
  });
  if (stacked) {
    return (
      <div className={`font-mono text-xs ${className}`} data-testid="dual-clock">
        <div className="text-cyan-400">
          <span className="text-[9px] tracking-widest text-gray-500 uppercase mr-2">UTC</span>{utc}
        </div>
        <div className="text-[#F4D03F]">
          <span className="text-[9px] tracking-widest text-gray-500 uppercase mr-2">EST</span>{est}
        </div>
      </div>
    );
  }
  return (
    <span className={`font-mono text-[10px] ${className}`} data-testid="dual-clock">
      <span className="text-cyan-400">UTC {utc}</span>
      <span className="text-gray-600 mx-2">·</span>
      <span className="text-[#F4D03F]">EST {est}</span>
    </span>
  );
}
